/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CertificationStatusDto } from '../models';
// @ts-ignore
import type { EmployeeCertificationDetailDto } from '../models';
// @ts-ignore
import type { EmployeeCertificationListResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * EmployeeCertificationApi - axios parameter creator
 * @export
 */
export const EmployeeCertificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns certification detail including all stages and their execution statuses for the given employee. 
         * @summary Get employee\'s certification detail with stages
         * @param {string} employeeId 
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeCertificationDetail: async (employeeId: string, certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeCertificationDetail', 'employeeId', employeeId)
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getEmployeeCertificationDetail', 'certificationId', certificationId)
            const localVarPath = `/api/v2/employees/{employeeId}/certifications/{certificationId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of certifications assigned to the employee. Only returns certifications in ACTIVE, COMPLETED or CANCELLED status. 
         * @summary Get employee\'s certifications
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CertificationStatusDto} [status] Filter by certification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeCertifications: async (employeeId: string, page?: number, pageSize?: number, status?: CertificationStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeCertifications', 'employeeId', employeeId)
            const localVarPath = `/api/v2/employees/{employeeId}/certifications`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeCertificationApi - functional programming interface
 * @export
 */
export const EmployeeCertificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeCertificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns certification detail including all stages and their execution statuses for the given employee. 
         * @summary Get employee\'s certification detail with stages
         * @param {string} employeeId 
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeCertificationDetail(employeeId: string, certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeCertificationDetail(employeeId, certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeCertificationApi.getEmployeeCertificationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of certifications assigned to the employee. Only returns certifications in ACTIVE, COMPLETED or CANCELLED status. 
         * @summary Get employee\'s certifications
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CertificationStatusDto} [status] Filter by certification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeCertifications(employeeId: string, page?: number, pageSize?: number, status?: CertificationStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCertificationListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeCertifications(employeeId, page, pageSize, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeCertificationApi.getEmployeeCertifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeCertificationApi - factory interface
 * @export
 */
export const EmployeeCertificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeCertificationApiFp(configuration)
    return {
        /**
         * Returns certification detail including all stages and their execution statuses for the given employee. 
         * @summary Get employee\'s certification detail with stages
         * @param {string} employeeId 
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeCertificationDetail(employeeId: string, certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeCertificationDetailDto> {
            return localVarFp.getEmployeeCertificationDetail(employeeId, certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of certifications assigned to the employee. Only returns certifications in ACTIVE, COMPLETED or CANCELLED status. 
         * @summary Get employee\'s certifications
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CertificationStatusDto} [status] Filter by certification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeCertifications(employeeId: string, page?: number, pageSize?: number, status?: CertificationStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeCertificationListResponseDto> {
            return localVarFp.getEmployeeCertifications(employeeId, page, pageSize, status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeCertificationApi - interface
 * @export
 * @interface EmployeeCertificationApi
 */
export interface EmployeeCertificationApiInterface {
    /**
     * Returns certification detail including all stages and their execution statuses for the given employee. 
     * @summary Get employee\'s certification detail with stages
     * @param {string} employeeId 
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationApiInterface
     */
    getEmployeeCertificationDetail(employeeId: string, certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeCertificationDetailDto>;

    /**
     * Returns paginated list of certifications assigned to the employee. Only returns certifications in ACTIVE, COMPLETED or CANCELLED status. 
     * @summary Get employee\'s certifications
     * @param {string} employeeId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {CertificationStatusDto} [status] Filter by certification status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationApiInterface
     */
    getEmployeeCertifications(employeeId: string, page?: number, pageSize?: number, status?: CertificationStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeCertificationListResponseDto>;

}

/**
 * EmployeeCertificationApi - object-oriented interface
 * @export
 * @class EmployeeCertificationApi
 * @extends {BaseAPI}
 */
export class EmployeeCertificationApi extends BaseAPI implements EmployeeCertificationApiInterface {
    /**
     * Returns certification detail including all stages and their execution statuses for the given employee. 
     * @summary Get employee\'s certification detail with stages
     * @param {string} employeeId 
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationApi
     */
    public getEmployeeCertificationDetail(employeeId: string, certificationId: number, options?: RawAxiosRequestConfig) {
        return EmployeeCertificationApiFp(this.configuration).getEmployeeCertificationDetail(employeeId, certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of certifications assigned to the employee. Only returns certifications in ACTIVE, COMPLETED or CANCELLED status. 
     * @summary Get employee\'s certifications
     * @param {string} employeeId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {CertificationStatusDto} [status] Filter by certification status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationApi
     */
    public getEmployeeCertifications(employeeId: string, page?: number, pageSize?: number, status?: CertificationStatusDto, options?: RawAxiosRequestConfig) {
        return EmployeeCertificationApiFp(this.configuration).getEmployeeCertifications(employeeId, page, pageSize, status, options).then((request) => request(this.axios, this.basePath));
    }
}

